import { IEntityDataService } from "@pit/core-data";
import { IDtoUser } from "@pit/frontend-model";
import { Observable } from "rxjs";

export interface IDtoUserEntityDataService extends IEntityDataService<IDtoUser> {

    getUserByUserName$(userName: string): Observable<IDtoUser>;
    getUserByUserNameAsync(userName: string): Promise<IDtoUser>;

    getWebUsersForMandator$(mandatorId: number): Observable<IDtoUser[]>;
    getWebUsersForMandatorAsync(mandatorId: number): Promise<IDtoUser[]>;

    getDeviceUsersForMandator$(mandatorId: number): Observable<IDtoUser[]>;
    getDeviceUsersForMandatorAsync(mandatorId: number): Promise<IDtoUser[]>;

    getUsersForDepot$(depotNumber: string): Observable<IDtoUser[]>;
    getUsersForDepotAsync(depotNumber: string): Promise<IDtoUser[]>;

}
